import React from 'react';
import styled from '@emotion/styled';
import PhoneInput, { getCountryCallingCode } from 'react-phone-number-input';
import CountrySelect from './CountrySelect';

const StyledPhoneInput = styled(PhoneInput)`
  display: flex;
  gap: 8px;
  height: 40px;

  > input {
    border: 1px solid #babcbf;
    border-radius: 2px !important;
    padding: 12px 8px !important;
  }

  button {
    color: #333;
  }
`;

const InputComponent = React.forwardRef((props, ref) => <input {...props} ref={ref} className="form-input" />);

/** @type {React.FC<import('react-phone-number-input').Props} */
const PhoneNumberInput = ({ className, onCountryChange, defaultCountry, ...rest }) => {
  const handleChangeCountry = country => {
    const prefix = getCountryCallingCode(country);
    onCountryChange(country, prefix);
  };

  return (
    <StyledPhoneInput
      className={className}
      {...rest}
      defaultCountry={defaultCountry.toUpperCase()}
      onCountryChange={handleChangeCountry}
      focusInputOnCountrySelection
      countrySelectComponent={CountrySelect}
      inputComponent={InputComponent}
    />
  );
};

export default PhoneNumberInput;
